const BASE_STYLES = `
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body {
      font-family: 'Segoe UI', system-ui, sans-serif;
      font-size: 13px;
      color: #1e293b;
      padding: 32px;
      max-width: 680px;
      margin: 0 auto;
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 28px;
      padding-bottom: 20px;
      border-bottom: 2px solid #7175ef;
    }
    .brand { font-size: 22px; font-weight: 800; color: #7175ef; letter-spacing: -0.5px; }
    .brand-sub { font-size: 11px; color: #94a3b8; margin-top: 2px; }
    .doc-title { text-align: right; }
    .doc-title h2 { font-size: 18px; font-weight: 700; color: #1e293b; }
    .doc-title .num { font-size: 13px; color: #7175ef; font-weight: 600; margin-top: 2px; }
    .doc-title .fecha { font-size: 11px; color: #94a3b8; margin-top: 2px; }
    .meta { display: grid; grid-template-columns: 1fr 1fr; gap: 8px 20px; margin-bottom: 24px; }
    .meta-item { }
    .meta-label { font-size: 10px; font-weight: 600; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.4px; }
    .meta-value { font-size: 13px; color: #1e293b; font-weight: 500; margin-top: 2px; }
    table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
    thead tr { background: #f8fafc; }
    th { padding: 8px 12px; text-align: left; font-size: 10px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; border-bottom: 1px solid #e2e8f0; }
    td { padding: 9px 12px; font-size: 13px; color: #374151; border-bottom: 1px solid #f1f5f9; }
    tr:last-child td { border-bottom: none; }
    .text-right { text-align: right; }
    .totals { margin-left: auto; width: 240px; }
    .totals-row { display: flex; justify-content: space-between; padding: 5px 0; font-size: 13px; color: #64748b; }
    .totals-total { display: flex; justify-content: space-between; padding: 10px 0 0; margin-top: 8px; border-top: 2px solid #7175ef; font-size: 16px; font-weight: 800; color: #1e293b; }
    .descuento { color: #16a34a; }
    .footer { margin-top: 40px; padding-top: 16px; border-top: 1px solid #e2e8f0; text-align: center; font-size: 10px; color: #94a3b8; }
    @media print {
      body { padding: 20px; }
      @page { margin: 12mm; }
    }
  </style>
`;

export const PLANTILLAS_DEFAULT = {
  venta: {
    tipo: 'venta',
    nombre: 'Factura de venta',
    html: `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <title>Factura de Venta #{{numero}}</title>
  ${BASE_STYLES}
</head>
<body>
  <div class="header">
    <div>
      <div class="brand">Pollería Ramírez</div>
      <div class="brand-sub">Sistema de gestión Arecore</div>
    </div>
    <div class="doc-title">
      <h2>Factura de Venta</h2>
      <div class="num">#{{numero}}</div>
      <div class="fecha">{{fecha}}</div>
    </div>
  </div>

  <div class="meta">
    <div class="meta-item">
      <div class="meta-label">Cliente</div>
      <div class="meta-value">{{cliente}}</div>
    </div>
    <div class="meta-item">
      <div class="meta-label">Forma de pago</div>
      <div class="meta-value">{{forma_pago}}</div>
    </div>
    <div class="meta-item">
      <div class="meta-label">Operador</div>
      <div class="meta-value">{{usuario}}</div>
    </div>
  </div>

  <table>
    <thead>
      <tr>
        <th>Producto</th>
        <th class="text-right">Cant.</th>
        <th class="text-right">Precio unit.</th>
        <th class="text-right">Subtotal</th>
      </tr>
    </thead>
    <tbody>
      {{#each items}}
      <tr>
        <td>{{producto}}</td>
        <td class="text-right">{{cantidad}} {{unidad}}</td>
        <td class="text-right">{{precio_unitario}}</td>
        <td class="text-right">{{subtotal}}</td>
      </tr>
      {{/each}}
    </tbody>
  </table>

  <div class="totals">
    <div class="totals-row"><span>Subtotal</span><span>{{subtotal_fmt}}</span></div>
    <div class="totals-row descuento"><span>Descuento</span><span>-{{descuento_fmt}}</span></div>
    <div class="totals-total"><span>Total</span><span>{{total_fmt}}</span></div>
  </div>

  <div class="footer">Documento generado por Arecore ERP · Gracias por su compra</div>
</body>
</html>`,
  },

  compra: {
    tipo: 'compra',
    nombre: 'Orden de compra',
    html: `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <title>Compra #{{id}}</title>
  ${BASE_STYLES}
</head>
<body>
  <div class="header">
    <div>
      <div class="brand">Pollería Ramírez</div>
      <div class="brand-sub">Sistema de gestión Arecore</div>
    </div>
    <div class="doc-title">
      <h2>Orden de Compra</h2>
      <div class="num">#{{id}}</div>
      <div class="fecha">{{fecha}}</div>
    </div>
  </div>

  <div class="meta">
    <div class="meta-item">
      <div class="meta-label">Proveedor</div>
      <div class="meta-value">{{proveedor}}</div>
    </div>
    <div class="meta-item">
      <div class="meta-label">Registrado por</div>
      <div class="meta-value">{{usuario}}</div>
    </div>
    <div class="meta-item">
      <div class="meta-label">Notas</div>
      <div class="meta-value">{{notas}}</div>
    </div>
  </div>

  <table>
    <thead>
      <tr>
        <th>Producto</th>
        <th class="text-right">Cant.</th>
        <th class="text-right">Precio unit.</th>
        <th class="text-right">Subtotal</th>
      </tr>
    </thead>
    <tbody>
      {{#each items}}
      <tr>
        <td>{{producto}}</td>
        <td class="text-right">{{cantidad}} {{unidad}}</td>
        <td class="text-right">{{precio_unitario}}</td>
        <td class="text-right">{{subtotal}}</td>
      </tr>
      {{/each}}
    </tbody>
  </table>

  <div class="totals">
    <div class="totals-total"><span>Total</span><span>{{total_fmt}}</span></div>
  </div>

  <div class="footer">Documento generado por Arecore ERP</div>
</body>
</html>`,
  },

  pago: {
    tipo: 'pago',
    nombre: 'Comprobante de pago a proveedor',
    html: `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <title>Pago #{{id}}</title>
  ${BASE_STYLES}
</head>
<body>
  <div class="header">
    <div>
      <div class="brand">Pollería Ramírez</div>
      <div class="brand-sub">Sistema de gestión Arecore</div>
    </div>
    <div class="doc-title">
      <h2>Comprobante de Pago</h2>
      <div class="num">#{{id}}</div>
      <div class="fecha">{{fecha}}</div>
    </div>
  </div>

  <div class="meta">
    <div class="meta-item">
      <div class="meta-label">Proveedor</div>
      <div class="meta-value">{{proveedor}}</div>
    </div>
    <div class="meta-item">
      <div class="meta-label">Forma de pago</div>
      <div class="meta-value">{{forma_pago}}</div>
    </div>
    <div class="meta-item">
      <div class="meta-label">Referencia / Comprobante</div>
      <div class="meta-value">{{referencia}}</div>
    </div>
    <div class="meta-item">
      <div class="meta-label">Registrado por</div>
      <div class="meta-value">{{usuario}}</div>
    </div>
    <div class="meta-item">
      <div class="meta-label">Notas</div>
      <div class="meta-value">{{notas}}</div>
    </div>
  </div>

  <div class="totals" style="margin-top:24px">
    <div class="totals-total"><span>Monto pagado</span><span>{{monto_fmt}}</span></div>
  </div>

  <div class="footer">Documento generado por Arecore ERP · Este comprobante tiene validez interna</div>
</body>
</html>`,
  },

  cobranza: {
    tipo: 'cobranza',
    nombre: 'Comprobante de cobranza',
    html: `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <title>Cobranza #{{id}}</title>
  ${BASE_STYLES}
</head>
<body>
  <div class="header">
    <div>
      <div class="brand">Pollería Ramírez</div>
      <div class="brand-sub">Sistema de gestión Arecore</div>
    </div>
    <div class="doc-title">
      <h2>Comprobante de Cobranza</h2>
      <div class="num">#{{id}}</div>
      <div class="fecha">{{fecha}}</div>
    </div>
  </div>

  <div class="meta">
    <div class="meta-item">
      <div class="meta-label">Cliente</div>
      <div class="meta-value">{{cliente}}</div>
    </div>
    <div class="meta-item">
      <div class="meta-label">Forma de pago</div>
      <div class="meta-value">{{forma_pago}}</div>
    </div>
    <div class="meta-item">
      <div class="meta-label">Referencia / Comprobante</div>
      <div class="meta-value">{{referencia}}</div>
    </div>
    <div class="meta-item">
      <div class="meta-label">Registrado por</div>
      <div class="meta-value">{{usuario}}</div>
    </div>
    <div class="meta-item">
      <div class="meta-label">Notas</div>
      <div class="meta-value">{{notas}}</div>
    </div>
  </div>

  <div class="totals" style="margin-top:24px">
    <div class="totals-total"><span>Monto cobrado</span><span>{{monto_fmt}}</span></div>
  </div>

  <div class="footer">Documento generado por Arecore ERP · Gracias por su pago</div>
</body>
</html>`,
  },
};

export const TIPOS_PLANTILLA = [
  { tipo: 'venta',     label: 'Factura de venta',             variables: ['numero','fecha','cliente','forma_pago','usuario','items[]','subtotal_fmt','descuento_fmt','total_fmt'] },
  { tipo: 'compra',    label: 'Orden de compra',              variables: ['id','fecha','proveedor','usuario','notas','items[]','total_fmt'] },
  { tipo: 'pago',      label: 'Comprobante de pago',          variables: ['id','fecha','proveedor','forma_pago','referencia','monto_fmt','usuario','notas'] },
  { tipo: 'cobranza',  label: 'Comprobante de cobranza',      variables: ['id','fecha','cliente','forma_pago','referencia','monto_fmt','usuario','notas'] },
];
